exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.voucherCodesList .icon {\n    color: red;\n    cursor: pointer;\n}\n.margin-top-medium {\n    margin-top: 15px!important;\n}\n", ""]);

// exports
